import dynamic from "next/dynamic";
const Navbar = dynamic(() => import("../Navbar"), {
  ssr: false,
});
import Image from "next/future/image";
import Link from "next/link";
import useScreenSize from "../../hooks/useScreenSize";

function Service2({ heading, paragraph, bgPath, textColor, mainHeading, styleClass, primaryCta = null, heroSvg = null }) {
  const size = useScreenSize();
  const isSmall = size == "sm" || size == "md";

  return (
    <>
      <Navbar />
      <div className={`h-fit max-h-auto flex items-center pt-12 ${styleClass}`} style={{ backgroundImage: isSmall && !heroSvg ? `url('${bgPath}')` : "" }}>
        <section
          className={`${heroSvg ? "" : "opacity-[0.7] md:opacity-100"} w-[100%] md:w-[65%] h-fit max-h-auto flex flex-col px-6 pb-16 pt-[50px] md:pt-12 ${textColor ? textColor : "text-services-main-txt"} service_txt  `}
        >
          {mainHeading ? <p className="text-2xl font-bold md:text-3xl py-6">{mainHeading}</p> : <></>}
          <h1 className="text-3xl font-bold md:text-5xl py-3">{heading}</h1>
          <div className="text-xl pt-8 whitespace-pre-line" dangerouslySetInnerHTML={{ __html: paragraph }} />
          {primaryCta && (
            <Link href={primaryCta.href} passHref>
              <a className="mt-8 inline-block self-start bg-[#f1aa4e] text-black font-semibold text-base px-6 py-3 rounded-md hover:bg-[#e09a3e] transition-colors">
                {primaryCta.label}
              </a>
            </Link>
          )}
        </section>
        <section className={heroSvg ? "hidden md:flex items-center justify-center w-[35%] py-16 px-8" : ""}>
          {heroSvg ? heroSvg : (
            <Image
              src={bgPath}
              className="w-auto h-[0vh] md:min-h-[100vh] mx-auto object-cover"
              width="500"
              height="500"
              alt={"how-digitisation-helps-formulation-companies"}
              sizes="(max-width: 500px) 50vw,
              (max-width: 1200px) 70vw, 100vw"
              placeholder="blur"
              blurDataURL={bgPath}
            />
          )}
        </section>
      </div>
    </>
  );
}

export default Service2;
